import React from "react";
import { Button, InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import PayrollTypeFormPresenter from "./PayrollTypeFormPresenter";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import FormFactory from "../../../../components/FormFactory";

class PayrollTtypeFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      objectID: "",
      object: {},
    };
    this.presenter = new PayrollTypeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "employees";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const employees = await findObjectUseCase().execute("employees");
    this.setState({ employees });
  }

  // handleInputChange(currentInput) {
  //   this.setState({ currentInput });
  // }

  setObject(object) {
    this.setState({ object });
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  async handleSubmit() {}

  render() {
    const { object } = this.state;
    const { selected, employeeData } = this.props;

    console.log("object", object);
    console.log("employeeData", employeeData);

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    const data =
      object && Object.keys(object).length !== 0
        ? object
        : { payrollRelation: employeeData?.payrollRelation || [] };

    console.log("data", data);

    const excludeFields = ["payrollRelation"];
    const fields = Object.keys(schema.fields).filter(
      (key) => !excludeFields.includes(key)
    );

    const employees = selected.length !== 0 ? selected : employeeData;

    const isMobile = window.innerWidth <= 768;

    return (
      <>
        <FloatingForm width="80%">
          <CardView style={{ padding: 0 }}>
            <>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.save();
                }}
              >
                <h4
                  className="fs-6 fw-bold"
                  style={{ padding: "0 1rem", paddingTop: "1rem" }}
                >
                  Assign to Employee(s)
                </h4>
                <hr />
                <div style={{ padding: "0 1rem" }}>
                  <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                    Assign to:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {(Array.isArray(employees) ? employees : [employees]).map(
                      (data, index) => {
                        return (
                          <div
                            key={index}
                            className={`${isMobile ? "w-50" : "w-25"} mb-2`}
                          >
                            <span style={{ fontSize: "15px" }}>
                              {data?.surname}, {data?.Firstname}{" "}
                              {data?.Middlename}
                            </span>
                          </div>
                        );
                      }
                    )}
                  </div>
                  <FormFactory
                    className="col-lg-12 p-1 mt-2"
                    uppercase
                    schema={schema}
                    object={data}
                    onChange={this.onChange.bind(this)}
                    excludeFields={fields}
                  />
                </div>
                <hr />

                <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                  <Button
                    className="btn btn-light fs-sm"
                    onClick={() => this.props.closeModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary"
                    // onClick={this.handleClickOk.bind(this)}
                  >
                    Assign
                  </Button>
                </div>
              </form>
            </>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}

export default withRouter(PayrollTtypeFormPage);
